import { Button } from "@/components/ui/button";
import { Mail, Phone, Linkedin, Facebook, Youtube, Instagram } from "lucide-react";
const TikTokIcon = () => (
  <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);
const Contact = () => {
  return (
    <section className="py-20 bg-primary text-primary-foreground">
      <div className="container px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-heading mb-6">
            Develop Leaders. Strengthen Teams. Transform Organizations.
          </h2>
          <p className="text-xl mb-8 opacity-90 leading-relaxed">
            Let's discuss how we can work together to unlock your full potential. Schedule a complimentary consultation
            to explore your goals.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button
              size="lg"
              variant="secondary"
              onClick={() =>
                window.open(" https://link.glowuplead.com/widget/service-menus/glowupleadprograms", "_blank")
              }
            >
              Schedule Free Consultation
            </Button>
            <Button size="lg" variant="outline" className="bg-white/10 border-white/30 hover:bg-white/20" asChild>
              <a href="/#programs">Program Guide</a>
            </Button>
          </div>

          <div className="flex flex-col gap-2 justify-center text-sm max-w-md mr-auto">
            <a
              href="mailto:ckyesmyland@glowuplead.com"
              className="flex items-center gap-2 justify-start py-2 px-4 rounded-lg hover:bg-white/10 active:bg-white/20 transition-all touch-manipulation"
            >
              <Mail className="w-5 h-5 flex-shrink-0" />
              <span className="text-base sm:text-sm">ckyesmyland@glowuplead.com</span>
            </a>
            <a
              href="tel:+13125980312"
              className="flex items-center gap-2 justify-start py-2 px-4 rounded-lg hover:bg-white/10 active:bg-white/20 transition-all touch-manipulation"
            >
              <Phone className="w-5 h-5 flex-shrink-0" />
              <span className="text-base sm:text-sm">+1 (312) 598-0312</span>
            </a>
            <a
              href="https://www.linkedin.com/company/glow-up-leadership-academy/about/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 justify-start py-2 px-4 rounded-lg hover:bg-white/10 active:bg-white/20 transition-all touch-manipulation"
            >
              <Linkedin className="w-5 h-5 flex-shrink-0" />
              <span className="text-base sm:text-sm">Glow Up Leadership Academy</span>
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61577908843407"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 justify-start py-2 px-4 rounded-lg hover:bg-white/10 active:bg-white/20 transition-all touch-manipulation"
            >
              <Facebook className="w-5 h-5 flex-shrink-0" />
              <span className="text-base sm:text-sm">Glow Up Leadership Academy</span>
            </a>
            <a
              href="https://www.instagram.com/GlowUpLEAD"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 justify-start py-2 px-4 rounded-lg hover:bg-white/10 active:bg-white/20 transition-all touch-manipulation"
            >
              <Instagram className="w-5 h-5 flex-shrink-0" />
              <span className="text-base sm:text-sm">@GlowUpLEAD</span>
            </a>
            <a
              href="https://www.tiktok.com/@glowupandlead"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 justify-start py-2 px-4 rounded-lg hover:bg-white/10 active:bg-white/20 transition-all touch-manipulation"
            >
              <TikTokIcon />
              <span className="text-base sm:text-sm">@glowupandlead</span>
            </a>
            <a
              href="https://www.youtube.com/@glowupandlead"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 justify-start py-2 px-4 rounded-lg hover:bg-white/10 active:bg-white/20 transition-all touch-manipulation"
            >
              <Youtube className="w-5 h-5 flex-shrink-0" />
              <span className="text-base sm:text-sm">@glowupandlead</span>
            </a>
          </div>

          <div className="mt-8 pt-6 border-t border-white/20">
            <p className="text-sm opacity-75">Glow Up LEADership Academy, LLC.</p>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Contact;
